import { Link } from "react-router-dom";
import { Sparkles, ShieldCheck, BadgeCheck } from "lucide-react";
import { Reveal } from "./Reveal";

const pillars = [
  {
    icon: Sparkles,
    title: "Built on AI",
    body: "ORIVA is powered by artificial-intelligence models. Every answer, summary, image and analysis in the app is generated by AI — there is no human typing on the other side.",
  },
  {
    icon: ShieldCheck,
    title: "Your data, respected",
    body: "We collect only what is needed to run the service, we never sell your personal data, and we explain everything in plain language in our Privacy Policy.",
    link: { to: "/privacy-policy", label: "Read the Privacy Policy" },
  },
  {
    icon: BadgeCheck,
    title: "Honest about accuracy",
    body: "AI can be wrong. Responses may be inaccurate, incomplete or outdated — always verify important information (academic, medical, legal or financial) with a qualified source before acting on it.",
  },
];

export const Trust = () => (
  <section id="trust" className="bg-white py-24 sm:py-32" data-testid="trust-section">
    <div className="mx-auto max-w-6xl px-5 sm:px-8">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">Trust & transparency</p>
        <h2 className="mt-4 max-w-2xl font-display text-4xl font-semibold tracking-tight text-slate-900 sm:text-5xl">
          Honest by design.
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-4 md:grid-cols-3">
        {pillars.map((pillar, i) => (
          <Reveal key={pillar.title} delay={i * 0.08}>
            <article
              className="flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-7"
              data-testid={`trust-card-${i}`}
            >
              <div className="grid h-11 w-11 place-items-center rounded-xl bg-blue-50">
                <pillar.icon className="h-5 w-5 text-oriva-blue" />
              </div>
              <h3 className="mt-5 font-display text-lg font-semibold tracking-tight text-slate-900">
                {pillar.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600">{pillar.body}</p>
              {pillar.link && (
                <Link
                  to={pillar.link.to}
                  data-testid="trust-privacy-link"
                  className="mt-4 text-sm font-medium text-oriva-blue underline-offset-4 transition-colors duration-200 hover:underline"
                >
                  {pillar.link.label}
                </Link>
              )}
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
